import {ChangeDetectionStrategy, Component, Injectable, input, viewChildren} from "@angular/core";
import {OppgaveModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {OppgaveListevisningKompaktKomponent} from "../oppgave-listevisning-kompakt/oppgave-listevisning-kompakt";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {delay} from "rxjs/operators";
import {OppgaveDatatjeneste} from "felles-ng2/tjenester/datalager/OppgaveDatatjeneste";
import {Observable} from "rxjs";

const debug = initDebugger('OppgavelisteKompaktKomponent');

/**
 * Lister oppgaver i kompakt form
 */
@Component({
    selector: 'oppgaveliste-kompakt',
    templateUrl: 'oppgaveliste-kompakt.html',
    styleUrl: 'oppgaveliste-kompakt.scss',
    host: {'data-testid': 'oppgaver'},
    imports: [
        OppgaveListevisningKompaktKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OppgavelisteKompaktKomponent {

    oppgaveElementer = viewChildren(OppgaveListevisningKompaktKomponent)

    oppgaver = input.required<OppgaveModell[]>();

    constructor(private avhengigheter: OppgavelisteKompaktKomponentAvhengigheter) {
        this.fokuserVedNyopprettet();
    }

    //private hjelpemetoder

    /** scroll til og blink når ny oppgave opprettes */
    private fokuserVedNyopprettet() {
        this.avhengigheter.vedNyOppgave
          .pipe(
            delay(100), //slik at den nye oppgave rekker å bli tegnet ut
            takeUntilDestroyed())
          .subscribe(nyOppgave =>
            this.oppgaveElementer()
              .find(element => element.oppgave().id === nyOppgave.id)
              ?.fokuser());
    }
}

@Injectable()
export class OppgavelisteKompaktKomponentAvhengigheter {

    constructor(private oppgaveDatatjeneste: OppgaveDatatjeneste) {
    }

    get vedNyOppgave(): Observable<OppgaveModell> {
        return this.oppgaveDatatjeneste.vedNyOppgave;
    }
}
